import React, { FC, useEffect, useState } from 'react';
import { deleteBlockedItem, fetchBlockList, setBlockListPagination } from '../../store/eligibility/actions/block-list';
import { useEligibilityContext } from '../../store/eligibility/eligibility-context';
import { IModalWindow, ModalWindow } from '../../components/modal/ModalWindow';
import { useDebounce } from 'use-debounce';
import { TablesNames } from '../../store/tables/tables-context';
import { Table } from '../../components/table/Table';
import { SearchInputSmall } from '../../components/common/SearchInputSmall';


export const BlockList: FC = () => {
	const {
		eligibilityState: {
			blockList,
			isBlockListLoading,
			blockListTablePageNumber,
			blockListTablePageSize,
			blockListTotalItemCount
		},
		dispatch
	} = useEligibilityContext();

	const [searchValue, setSearchValue] = useState<string>('');
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	const [value] = useDebounce(searchValue.toLowerCase().trim(), 1000);

		console.log('here', blockListTablePageSize);
	useEffect(() => {
		void fetchBlockList(dispatch, blockListTablePageNumber + 1, blockListTablePageSize, value);
	}, [blockListTablePageNumber, blockListTablePageSize, value]);

	const openDeleteModal = (id): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Delete',
			minHeight: 100,
			content: (
				<>
					<div className="text-center fs-5">Attention! This action cannot be undone.</div>
					<div className="text-center fs-5">Press `Delete` to continue.</div>
				</>
			),
			onCancel: closeModal,
			confirmButtonText: 'Delete',
			onConfirm: async () => {
				await deleteBlockedItem(id);
				await fetchBlockList(dispatch, blockListTablePageNumber + 1, blockListTablePageSize, value);
				closeModal();
			}
		});
	};

	const rowActions = (rowData): JSX.Element => {
		return (
			<div
				onClick={(): void => openDeleteModal(rowData?.original?.id)}
				className="text-center text-muted fw-bolder cursor-pointer fs-7"
			>
				Delete
			</div>
		);
	};

	return (
		<>
			<div className="card bg-transparent mb-5">
				<div className="card-body px-0 py-0">
					<div className="d-flex align-items-center application-selector">
						<SearchInputSmall
							placeholder="Search by Meta"
							searchValue={searchValue}
							setSearchValue={setSearchValue}
						/>
					</div>
				</div>
			</div>

			<Table
				name={TablesNames.blockListTableData}
				data={blockList ?? []}
				// pageNumber={blockListTablePageNumber}
				// pageSize={blockListTablePageSize}
				isLoading={isBlockListLoading}
				totalItemCount={blockListTotalItemCount}
				setPagination={(value): void => setBlockListPagination(dispatch, value)}
				enableRowActions={true}
				rowActions={rowActions}
				// actionColumnsSize={isAdmin ? 100 : 50}
			/>

			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>
		</>
	);
};
